import { Anchor, Typography } from "antd";
import { AnchorProps } from "antd/lib";
import classNames from "classnames";
import { PropsWithChildren } from "react";
import { twMerge } from "tailwind-merge";
import { PropsWithClassAndStyle } from "utils/props";
import { FloatingTOC, TOCItem } from "./TOC";
import Logo from "./Logo";
import { Navbar, NavbarLinks } from "./Navbar";

interface TOC {
  items: TOCItem[]
}

export function ContentPage({ children, className, style, extraWide, wide, toc }: PropsWithClassAndStyle<PropsWithChildren<{ extraWide?: boolean; wide?: boolean; toc?: TOC }>>) {
  // TODO: footer

  const szcls = classNames({ 'max-w-40': true, '!max-w-90': extraWide, '!max-w-60': wide })
  return <div className="w-full">
    <div className="py-0.5 px-3 max-3xl:px-1 flex justify-between">
      <Logo width={100} height={100} />
    
      <NavbarLinks user={undefined} />

      <div style={{width: 50, height: 50}}></div>
    </div>    <div className={twMerge(classNames("px-2 mx-auto py-2 prose prose-table:border-light-grey prose-td:border-light-grey", szcls), className)} style={style}>
      {/* {toc && <span className="absolute 4xl:w-20 right-10 max-4xl:right-0 max-2xl:w-13 2xl:w-15  max-xl:hidden"> */}
      {/*   <Anchor offsetTop={24} className="overflow-hidden overflow-y-auto" items={toc.items} /> */}
      {/* </span>} */}
      {/* {toc && <FloatingTOC items={toc.items} />} */}

      {children}
    </div>
  </div>
}
export function ContentPageAnt({ children, extraWide, wide }: PropsWithChildren<{ extraWide?: boolean; wide?: boolean }>) {
  // TODO: footer
  const szcls = classNames({ 'max-w-40': true, '!max-w-90': extraWide, '!max-w-60': wide })
  return <div className="w-full">
    <div className="px-2 py-1 flex justify-between">
      <Logo width={100} height={100} />
    </div>
    <Typography className={classNames("px-2 mx-auto py-2", szcls)}>
      {children}
    </Typography>
  </div>
}



